<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'label.registerEvidenceRemoteIsland' | staticMsg"
        [titleAria]="'reader.certificate RegistrationDiscountsIsolatedIsland' | staticMsg"
        itemId="register-evidence-island"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
